var $body = $('body');
new WOW().init();
document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});
$(document).ready(function () {
    // Navbar expand
    navbar_expand();
    // Animation slider
    var animSlider = $('.anim-slider');
    if (animSlider.length) {
        if (animSlider.find('.anim-slide').length > 1) {
            animSlider.animateSlider({
                autoplay: true, //starts the autoplay 
                interval: 10,
                elemAnimate: true,
                animations: {
                    0: {
                        ".event-point": {
                            show: "slideInRight",
                            hide: "slideOutLeft",
                            delayShow: "delay0-1s"
                        },
                        ".event-point-item": {
                            show: "slideInDown",
                            hide: "slideOutUp",
                            delayShow: "delay1s"
                        },
                        ".headline": {
                            show: "slideInDown",
                            hide: "slideOutUp",
                            delayShow: "delay1"
                        },
                        li: {
                            show: "fadeIn",
                            hide: "fadeOut",
                            delayShow: "delay0-1s"
                        }
                    },
                    1: {
                        ".event-point": {
                            show: "slideInUp",
                            hide: "slideOutDown",
                            delayShow: "delay0-1s"
                        },
                        ".event-point-item": {
                            show: "slideInLeft",
                            hide: "slideOutRight",
                            delayShow: "delay1s"
                        },
                        ".headline": {
                            show: "slideInRight",
                            hide: "slideOutLeft",
                            delayShow: "delay1"
                        },
                        li: {
                            show: "fadeIn",
                            hide: "fadeOut",
                            delayShow: "delay0-1s"
                        }
                    }
                }
            });
            $('.anim-arrows').show();
        } else {
            animSlider.show();
            $('.anim-arrows').hide();
        }
    }
    //Mobile Menu
    $('.menu-trigger').on('click', function () {
        $('body').toggleClass('menu--open');
        nav_height();
    });
    // Go to bottom
    $('.scroll-down').bind('click', function (event) {
        $('html, body').stop().animate({
            scrollTop: ($(this).parent().next('section').offset().top - 55)
        }, 800);
        event.preventDefault();
    });
    // Go to top
    $(".goto-top").click(function () {
        $("html, body").animate({ scrollTop: 0 }, 1000);
        return false;
    });
    // Search Text Toggle
    $('.search-btn').click(function () {
        $('.navigation').toggleClass('search-show');
    });
    //testimonial carousel    
    var testimonialSlider = $('.testimonial-slider-int');
    if (testimonialSlider.length) {
        if (testimonialSlider.find('.testimonial-slide').length > 1) {
            testimonialSlider.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                loop: true,
                autoplay: true,
                onInitialize: function () {
                    if (testimonialSlider.find('.testimonial-slide').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        } else {
            testimonialSlider.show();
        }
    }
    //speakers carousel
    var speakersSlider = $('.speakers-slider-int');
    if (speakersSlider.length) {
        if (speakersSlider.find('.speakers-slide').length > 1) {
            speakersSlider.owlCarousel({
                items: 3,
                nav: false,
                dots: true,
                loop: true,
                autoplay: true,
                margin: 30,
                responsive: {
                    0: {
                        items: 1,
                    },
                    576: {
                        items: 2,
                    },
                    992: {
                        items: 3,
                    }
                },
                onInitialize: function () {
                    if (speakersSlider.find('.speakers-slide').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        } else {
            speakersSlider.show();
        }
    }
    /*Tab Element*/
    $(".tab_content").hide();
    $(".tab_content:first").show();
    /* if in tab mode */
    $("ul.tabs li").click(function () {

        $(".tab_content").hide();
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).fadeIn();

        $("ul.tabs li").removeClass("active");
        $(this).addClass("active");

        $(".tab_drawer_heading").removeClass("d_active");
        $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

    });
    /* if in drawer mode */
    $(".tab_drawer_heading").click(function () {

        $(".tab_content").hide();
        var d_activeTab = $(this).attr("rel");
        $("#" + d_activeTab).fadeIn();

        $(".tab_drawer_heading").removeClass("d_active");
        $(this).addClass("d_active");

        $("ul.tabs li").removeClass("active");
        $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
    });
    /* Extra class "tab_last" to add border to right side of last tab */
    $('ul.tabs li').last().addClass("tab_last");

});
$(window).resize(function () {
    nav_height();
    /*isotope_masonry Function*/
    isotope_masonry();
});
$(window).on('load', function () {
    //Preloader JS code
    $('.status').delay(500).fadeOut(); // will first fade out the loading animation 
    $('.preloader').delay().fadeOut(); // will fade out the white DIV that covers the website. 

    /*isotope_masonry Function*/
    isotope_masonry();
});
var stickyOffset = $('header').height();
var previousScroll = 0;
$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    // Fixed Menu
    if (scroll >= stickyOffset) {
        $('body').addClass('fixed-header');
    } else {
        $('body').removeClass('fixed-header');
    }

    /* for go to top arrow */
    var currentScroll = $(this).scrollTop();
    if (currentScroll > previousScroll) {
        if (scroll >= stickyOffset + 100) {
            $('.goto-top').addClass('visible');
        }
    } else {
        $('.goto-top').removeClass('visible');
    }

    // code for counter 
    if ($('.counter-section').length) {
        var count_scroll = $('.counter-section').offset().top - win_height();
        if (scroll > count_scroll) {
            $('.animation-counter').each(function (index) {
                init_odometer(this);
            });
        }
    }

});

function nav_height() {
    if (win_width() > 991) {
        $('.navigation').css('height', 'auto');
        $('.navigation').css('margin-top', 0);
    } else {
        $('.navigation').css('height', win_height() - header_height() + 1);
        $('.navigation').css('margin-top', header_height() - 1);
    }
}
function win_height() {
    return $(window).outerHeight();
}
function win_width() {
    return $(window).width();
}
function header_height() {
    return $('header.page').outerHeight();
}

function navbar_expand() {
    if ($(window).width() >= 992) {
        $('.has-sub-menu').hover(function () {
            $(this).children('.sub-menu-list').toggleClass('has-menu-open');
        });
    } else {
        $('.menu-toggle-ico').click(function () {
            $(this).toggleClass('rotate-ico');
            $(this).siblings('.sub-menu-list').toggleClass('has-menu-open');
            $(this).siblings('.mega-sub-menu').toggleClass('has-menu-open');
            $(this).siblings('.grid-menu').toggleClass('has-menu-open');
        });
    }
}
/*Odometer Function*/
function init_odometer(el) {
    if ($('.animation-counter-odometer', el).size() == 0)
        return;
    var odometer = $('.animation-counter-odometer', el).get(0);
    var format = $(el).closest('.animation-counter-box').data('number-format');
    format = format ? format : '(ddd).ddd';
    var od = new Odometer({
        el: odometer,
        value: $(odometer).text(),
        format: format
    });
    od.update($(odometer).data('to'));
}
/*isotope_masonry Function*/
function isotope_masonry() {
    //portfolio Isotope plugins initialize
    $GalleryGrid = $('.gallery-grid').isotope({
        itemSelector: '.gallery-grid-item',
        layoutMode: "packery",
    });
    // filter items on button click
    $('.js-filter').on('click', 'button', function () {
        var filterValue = $(this).attr('data-filter');
        $GalleryGrid.isotope({
            filter: filterValue
        });
        $('.js-filter button').removeClass('is-active');
        $(this).addClass('is-active');
    });
}